import React, { useState, useRef, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { handleChatAndMessage } from '../../redux/shared/actions.js';
import styles from './ChatComposer.module.css';
import Send from './Send.svg';

function ChatComposer() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const textareaRef = useRef(null);
  const [message, setMessage] = useState('');
  const isDisabled = message === "" ? true : false;

  const user_id = useSelector((state) => state.user.user_id);
  const messages = useSelector((state) => state.message.messages);
  const modelName = useSelector((state) => state.shared.model_name)

  const handleClick = async () => {
    if (user_id) {
      setMessage('');
      await dispatch(handleChatAndMessage(user_id, id, message, modelName, messages, navigate));
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (e.shiftKey) {
        setMessage((prevMessage) => prevMessage + '\n');
      } else {
        e.preventDefault();
        handleClick();
      }
    }
  };

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto'; 
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  useEffect(() => {
    adjustTextareaHeight();
  }, []);

  useEffect(() => {
    adjustTextareaHeight();
  }, [message]);

  return (
    <div className={styles.layout}>
      <div className={styles.inputContainer}>
        <textarea 
          ref={textareaRef}
          className={styles.input}
          type='text' 
          placeholder='Type a message...'
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          rows="1"
        />
        <button 
          className={styles.send} 
          onClick={handleClick} 
          disabled={isDisabled}
        >
          <img src={Send} alt='Send' />
        </button>
      </div>
      <div className={styles.powered_by}>Powered by <a href="https://larryheck.github.io/avalab/" target="_blank" rel="noreferrer">AVA Lab</a></div>
    </div>
  );
}

export default ChatComposer;
